import MembershipAnalyticsByYearReportView from "../../features/MetabaseDashboard/MembershipAnalyticsByYearReportView"

const MembershipAnalyticsByYear = () => {
  return (
    <div><MembershipAnalyticsByYearReportView /></div>
  )
}

export default MembershipAnalyticsByYear